import { all, put, call, takeLatest } from 'redux-saga/effects'

import { request } from '../../services/client'
import { ActionTypes } from '../constants/actions';
import { APIEndpoints } from '../constants';
import { getCookie } from '../../services/cookie';

/**
 * Login
 */
export function* getAccountDetails(action) {
    try {
        const response = yield call(request, action.payload.role === 'super_admin' ? APIEndpoints.GET_SUPERADMIN_ACCOUNT_DETAILS() : APIEndpoints.GET_ACCOUNT_DETAILS(action.payload.role), {
            method: 'GET'
        })
        yield put({
            type: ActionTypes.GET_ACCOUNT_DETAILS_SUCCESS,
            payload: response
        })
    } catch (err) {
        /* istanbul ignore next */
        yield put({
            type: ActionTypes.GET_ACCOUNT_DETAILS_FAILURE,
            payload: err.error
        })
    }
}

export function* updateAccountDetails(action) {
    try {
        const { name, email } = action.payload
        const role = getCookie('role');
        const apiEndpoint = role === 'read_only_user' ? APIEndpoints.UPDATE_STAKEHOLDER_ACCOUNT_DETAILS : role === 'super_admin'? APIEndpoints.UPDATE_SUPERADMIN_ACCOUNT_DETAILS() : APIEndpoints.UPDATE_ACCOUNT_DETAILS(action.payload.role)
        const response = yield call(request, apiEndpoint, {
            method: 'PUT',
            payload: { name, email }
        })
        yield put({
            type: ActionTypes.UPDATE_ACCOUNT_DETAILS_SUCCESS,
            payload: response
        })
    } catch (err) {
        /* istanbul ignore next */
        yield put({
            type: ActionTypes.UPDATE_ACCOUNT_DETAILS_FAILURE,
            payload: err
        })
    }
}

export function* getUserCompanyDetails(action) {
    try {
        const response = yield call(request, APIEndpoints.GET_USER_COMPANY_DETAILS(action.payload.role), {
            method: 'GET'
        })
        yield put({
            type: ActionTypes.GET_USER_COMPANY_DETAILS_SUCCESS,
            payload: response.company
        })
    } catch (err) {
        /* istanbul ignore next */
        yield put({
            type: ActionTypes.GET_USER_COMPANY_DETAILS_FAILURE,
            payload: err.error
        })
    }
}

export function* updateCompanyDetails(action) {
    try {
        const { isAuditor, name, email, phone, website, year } = action.payload
        const apiEndpoint = isAuditor ? APIEndpoints.UPDATE_AUDITOR_COMPANY : APIEndpoints.UPDATE_COMPANY_DETAILS;
        const response = yield call(request, apiEndpoint, {
            method: 'PUT',
            payload: { name, email, phone, website, estd_year: year }
        })
        yield put({
            type: ActionTypes.UPDATE_COMPANY_DETAILS_SUCCESS,
            payload: response
        })
    } catch (err) {
        /* istanbul ignore next */
        yield put({
            type: ActionTypes.UPDATE_COMPANY_DETAILS_FAILURE,
            payload: err
        })
    }
}

export function* getStakeholderAccount(action) {
    try {
        const response = yield call(request, APIEndpoints.GET_STAKEHOLDER_ACCOUNT(action.payload.role), {
            method: 'GET'
        })
        yield put({
            type: ActionTypes.GET_STAKEHOLDER_ACCOUNT_SUCCESS,
            payload: response
        })
    } catch (err) {
        /* istanbul ignore next */
        yield put({
            type: ActionTypes.GET_STAKEHOLDER_ACCOUNT_FAILURE,
            payload: err.error
        })
    }
}

export default function* root() {
    yield all([
        takeLatest(ActionTypes.GET_ACCOUNT_DETAILS, getAccountDetails),
        takeLatest(ActionTypes.UPDATE_ACCOUNT_DETAILS, updateAccountDetails),
        takeLatest(ActionTypes.GET_USER_COMPANY_DETAILS, getUserCompanyDetails),
        takeLatest(ActionTypes.UPDATE_COMPANY_DETAILS, updateCompanyDetails),
        takeLatest(ActionTypes.GET_STAKEHOLDER_ACCOUNT, getStakeholderAccount),
    ])
}
